import React from 'react';
import { Heading, Tag } from '@innovationnorway/cl-react';
import { CompanySizeCriteria, OneWayInServiceDto } from 'src/api/v2';
import './ServiceInfoPanel.scss';
import { useTranslation } from 'react-i18next';
import { sanitizeD365RichTextEditor } from 'src/features/one-way-in/utils/htmlTextConverter';
import useTargetPageOptions from 'src/features/services/register-service-form/hooks/use-target-page-options';

const ServiceInfoPanel = ({ service }: { service: OneWayInServiceDto }) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const { companyAgeOptions, companySizeOptions } = useTargetPageOptions();

  return (
    <div className="service-info-panel">
      <Heading level={2} className="service-info-panel__heading">
        {service.name}
      </Heading>

      <div className="service-info-panel__field">
        <p className="service-info-panel__label">{tOneWayIn('referring.serviceDescription')}</p>
        <div
          className="service-info-panel__value"
          dangerouslySetInnerHTML={{ __html: sanitizeD365RichTextEditor(service.description || '') }}
        />
      </div>

      <div className="service-info-panel__field">
        <p className="service-info-panel__label">{tOneWayIn('referring.companyAge')}</p>
        <p className="service-info-panel__value">
          {companyAgeOptions.find((option) => option.value === service.companyAge)?.label}
        </p>
      </div>

      <div className="service-info-panel__field">
        <p className="service-info-panel__label">{tOneWayIn('referring.companySize')}</p>
        <div className="service-info-panel__value service-info-panel__value--tags">
          {companySizeOptions
            .filter((option) => service.companySize?.includes(option.value as CompanySizeCriteria))
            .map((option) => (
              <Tag key={String(option.label)} data-color={'info' as const}>
                {option.label}
              </Tag>
            ))}
        </div>
      </div>

      <div className="service-info-panel__field">
        <p className="service-info-panel__label">{tOneWayIn('referring.deliveryTypes')}</p>
        <div className="service-info-panel__value service-info-panel__value--tags">
          {service.deliveryTypes.map((type) => (
            <Tag key={type} data-color={'info' as const}>
              {tOneWayIn(`deliveryType.${type}`)}
            </Tag>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceInfoPanel;
